/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPaginatedListOfCustomerSummaryFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type CustomerType, type MidMeterType, type PaginatedListOfCustomerSummary, type ProblemDetails, type SettlementEligibility } from '../models/index.js';
// @ts-ignore
import { ActivityRequestBuilderNavigationMetadata, ActivityRequestBuilderRequestsMetadata, type ActivityRequestBuilder } from './activity/index.js';
// @ts-ignore
import { AffiliatecodesRequestBuilderRequestsMetadata, type AffiliatecodesRequestBuilder } from './affiliatecodes/index.js';
// @ts-ignore
import { BusinessRequestBuilderNavigationMetadata, BusinessRequestBuilderRequestsMetadata, type BusinessRequestBuilder } from './business/index.js';
// @ts-ignore
import { ChargermakesRequestBuilderRequestsMetadata, type ChargermakesRequestBuilder } from './chargermakes/index.js';
// @ts-ignore
import { ConsumerRequestBuilderNavigationMetadata, ConsumerRequestBuilderRequestsMetadata, type ConsumerRequestBuilder } from './consumer/index.js';
// @ts-ignore
import { DataSharingGrantsRequestBuilderNavigationMetadata, type DataSharingGrantsRequestBuilder } from './dataSharingGrants/index.js';
// @ts-ignore
import { ExportRequestBuilderRequestsMetadata, type ExportRequestBuilder } from './exportEscaped/index.js';
// @ts-ignore
import { CustomerItemRequestBuilderNavigationMetadata, CustomerItemRequestBuilderRequestsMetadata, type CustomerItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { TagsRequestBuilderNavigationMetadata, TagsRequestBuilderRequestsMetadata, type TagsRequestBuilder } from './tags/index.js';
// @ts-ignore
import { TodateRequestBuilderNavigationMetadata, TodateRequestBuilderRequestsMetadata, type TodateRequestBuilder } from './todate/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /customers
 */
export interface CustomersRequestBuilder extends BaseRequestBuilder<CustomersRequestBuilder> {
    /**
     * The activity property
     */
    get activity(): ActivityRequestBuilder;
    /**
     * The affiliatecodes property
     */
    get affiliatecodes(): AffiliatecodesRequestBuilder;
    /**
     * The business property
     */
    get business(): BusinessRequestBuilder;
    /**
     * The chargermakes property
     */
    get chargermakes(): ChargermakesRequestBuilder;
    /**
     * The consumer property
     */
    get consumer(): ConsumerRequestBuilder;
    /**
     * The dataSharingGrants property
     */
    get dataSharingGrants(): DataSharingGrantsRequestBuilder;
    /**
     * The export property
     */
    get exportEscaped(): ExportRequestBuilder;
    /**
     * The tags property
     */
    get tags(): TagsRequestBuilder;
    /**
     * The todate property
     */
    get todate(): TodateRequestBuilder;
    /**
     * Gets an item from the ApiSdk.customers.item collection
     * @param customerId Unique identifier of the item
     * @returns {CustomerItemRequestBuilder}
     */
     byCustomerId(customerId: Guid) : CustomerItemRequestBuilder;
    /**
     * GetCustomers
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedListOfCustomerSummary>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<CustomersRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedListOfCustomerSummary | undefined>;
    /**
     * GetCustomers
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<CustomersRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * GetCustomers
 */
export interface CustomersRequestBuilderGetQueryParameters {
    affiliateCodes?: string[];
    chargerMakes?: string[];
    criteria?: string;
    customerType?: CustomerType;
    eligibility?: SettlementEligibility;
    midMeters?: MidMeterType[];
    pageNumber?: number;
    pageSize?: number;
    sortExpression?: string;
    tags?: string[];
}
/**
 * Uri template for the request builder.
 */
export const CustomersRequestBuilderUriTemplate = "{+baseurl}/customers{?AffiliateCodes*,ChargerMakes*,Criteria*,CustomerType*,Eligibility*,MidMeters*,PageNumber*,PageSize*,SortExpression*,Tags*}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const CustomersRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "affiliateCodes": "AffiliateCodes",
    "chargerMakes": "ChargerMakes",
    "criteria": "Criteria",
    "customerType": "CustomerType",
    "eligibility": "Eligibility",
    "midMeters": "MidMeters",
    "pageNumber": "PageNumber",
    "pageSize": "PageSize",
    "sortExpression": "SortExpression",
    "tags": "Tags",
};
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CustomersRequestBuilderNavigationMetadata: Record<Exclude<keyof CustomersRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byCustomerId: {
        requestsMetadata: CustomerItemRequestBuilderRequestsMetadata,
        navigationMetadata: CustomerItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["customer%2Did"],
    },
    activity: {
        requestsMetadata: ActivityRequestBuilderRequestsMetadata,
        navigationMetadata: ActivityRequestBuilderNavigationMetadata,
    },
    affiliatecodes: {
        requestsMetadata: AffiliatecodesRequestBuilderRequestsMetadata,
    },
    business: {
        requestsMetadata: BusinessRequestBuilderRequestsMetadata,
        navigationMetadata: BusinessRequestBuilderNavigationMetadata,
    },
    chargermakes: {
        requestsMetadata: ChargermakesRequestBuilderRequestsMetadata,
    },
    consumer: {
        requestsMetadata: ConsumerRequestBuilderRequestsMetadata,
        navigationMetadata: ConsumerRequestBuilderNavigationMetadata,
    },
    dataSharingGrants: {
        navigationMetadata: DataSharingGrantsRequestBuilderNavigationMetadata,
    },
    exportEscaped: {
        requestsMetadata: ExportRequestBuilderRequestsMetadata,
    },
    tags: {
        requestsMetadata: TagsRequestBuilderRequestsMetadata,
        navigationMetadata: TagsRequestBuilderNavigationMetadata,
    },
    todate: {
        requestsMetadata: TodateRequestBuilderRequestsMetadata,
        navigationMetadata: TodateRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const CustomersRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: CustomersRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedListOfCustomerSummaryFromDiscriminatorValue,
        queryParametersMapper: CustomersRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
